// extracted by mini-css-extract-plugin
module.exports = {"VennDiagram":"VennDiagram_VennDiagram__g_pS0","Logo":"VennDiagram_Logo__Qc2Dx","Image":"VennDiagram_Image__v9hqT","Text":"VennDiagram_Text__aulFd"};